import React, { useCallback } from 'react'
import Switch from '@wongnai/ui/components/Switch'
import { orange } from '@wongnai/ui/styles/colors'

interface SwitchProps {
  checked: boolean
  field: string
  onChange: (field: string, isChecked: boolean) => void
}

const NotificationSwitch = ({ checked, field, onChange }: SwitchProps) => {
  const toggleCheck = useCallback(() => {
    onChange(field, !checked)
  }, [checked, field, onChange])

  return (
    <Switch
      checked={checked}
      baseColor={orange[50]}
      handleColor={orange[500]}
      onChange={toggleCheck}
      disabled={false}
    />
  )
}

export default NotificationSwitch
